<template>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useOnboardingRouter } from '@/router/routers';

const props = defineProps({id: String});
const store = useStore();
const router = useOnboardingRouter();

const dispatch = () => store.dispatch('context/onboard', props.id)
const onboarded = () => new Promise((r, _) => r(dispatch()));
const redirect = () => router.dashboard();

const onMount = onMounted(() => onboarded().then(redirect));
</script>
